import React from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';
import { obterDataHoraPartes } from '~/modules/Helper/DateTimeHelper';
import { UltimaAtualizacaoArea } from './Footer.styled';

export function UltimaAtualizacao({ dataHora, corTituloGrid }) {
  const { data, hora } = obterDataHoraPartes(dataHora);

  return (
    <UltimaAtualizacaoArea corTituloGrid={corTituloGrid}>
      <div className="title">Última Atualização:</div>
      <div className="dates">
        <p>{data}</p>
        <p>
          <ClockCircleOutlined style={{ marginRight: 3 }} />
          {hora}
        </p>
      </div>
    </UltimaAtualizacaoArea>
  );
}
